/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Filter Comparison Operator
 * @export
 */
export const FilterComparator = {
    Equal: '=',
    NotEqual: '!=',
    LessThan: '<',
    GreaterThan: '>',
    LessThanOrEqualTo: '<=',
    GreaterThanOrEqualTo: '>=',
    Like: 'LIKE',
    In: 'IN',
    NotIn: 'NOT IN',
    IsNull: 'IS NULL',
    IsNotNull: 'IS NOT NULL'
} as const;
export type FilterComparator = typeof FilterComparator[keyof typeof FilterComparator];


export function instanceOfFilterComparator(value: any): boolean {
    for (const key in FilterComparator) {
        if (Object.prototype.hasOwnProperty.call(FilterComparator, key)) {
            if (FilterComparator[key as keyof typeof FilterComparator] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FilterComparatorFromJSON(json: any): FilterComparator {
    return FilterComparatorFromJSONTyped(json, false);
}

export function FilterComparatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterComparator {
    return json as FilterComparator;
}

export function FilterComparatorToJSON(value?: FilterComparator | null): any {
    return value as any;
}

